module.exports = __webpack_public_path__ + "static/media/refresh_black_24dp.cedb06c8.svg";